export const entityRelationOptions = [
  {
    label: 'autor/tvůrce',
    id: 'RT_AUTHOR',
  },
  {
    label: 'autor změny / tvůrce změny',
    id: 'RT_AUTHOROFCHANGE',
  },
  {
    label: 'babička',
    id: 'RT_GRANDMOTHER',
  },
  {
    label: 'bratr',
    id: 'RT_BROTHER',
  },
  {
    label: 'bratranec',
    id: 'RT_HECOUSIN',
  },
  {
    label: 'celek',
    id: 'RT_WHOLE',
  },
  {
    label: 'ceremoniál ocenění',
    id: 'RT_CEREMONY',
  },
  {
    label: 'je členem rodiny/rodu',
    id: 'RT_GENUSMEMBER',
  },
  {
    label: 'členská organizace',
    id: 'RT_MEMBERORG',
  },
  {
    label: 'další rodinné vztahy',
    id: 'RT_RELATIONS',
  },
  {
    label: 'dědeček',
    id: 'RT_GRANDFATHER',
  },
  {
    label: 'dokument',
    id: 'RT_DOCUMENT',
  },
  {
    label: 'entita související se začátkem',
    id: 'RT_ENTITYORIGIN',
  },
  {
    label: 'entita související se vznikem',
    id: 'RT_ENTITYRISE',
  },
  {
    label: 'entita související s koncem',
    id: 'RT_ENTITYEND',
  },
  {
    label: 'entita související se zánikem',
    id: 'RT_ENTITYEXTINCTION',
  },
  {
    label: 'entita související s narozením',
    id: 'RT_ENTITYBIRTH',
  },
  {
    label: 'entita související s úmrtím',
    id: 'RT_ENTITYDEATH',
  },
  {
    label: 'funkce/činnost',
    id: 'RT_FUNCTION',
  },
  {
    label: 'geografická působnost',
    id: 'RT_GEOSCOPE',
  },
  {
    label: 'historický milník',
    id: 'RT_MILESTONE',
  },
  {
    label: 'je část',
    id: 'RT_ISPART',
  },
  {
    label: 'je členem',
    id: 'RT_ISMEMBER',
  },
  {
    label: 'jiná entita reprezentující tutéž osobu',
    id: 'RT_OTHERNAME',
  },
  {
    label: 'jiný předek',
    id: 'RT_ANCESTOR',
  },
  {
    label: 'korporace veřejného působení',
    id: 'RT_ACTIVITYCORP',
  },
  {
    label: 'likvidátor',
    id: 'RT_LIQUIDATOR',
  },
  {
    label: 'majitel',
    id: 'RT_OWNER',
  },
  {
    label: 'majitel, držitel',
    id: 'RT_HOLDER',
  },
  {
    label: 'manžel',
    id: 'RT_HUSBAND',
  },
  {
    label: 'manželka',
    id: 'RT_WIFE',
  },
  {
    label: 'matka',
    id: 'RT_MOTHER',
  },
  {
    label: 'místo',
    id: 'RT_PLACE',
  },
  {
    label: 'místo konání',
    id: 'RT_VENUE',
  },
  {
    label: 'místo ukončení',
    id: 'RT_PLACEEND',
  },
  {
    label: 'místo uzavření',
    id: 'RT_PLACESTART',
  },
  {
    label: 'nadřazená korporace',
    id: 'RT_SUPCORP',
  },
  {
    label: 'nadřazený pojem',
    id: 'RT_SUPTERM',
  },
  {
    label: 'nadřízený',
    id: 'RT_SENIOR',
  },
  {
    label: 'nástupce',
    id: 'RT_SUCCESSOR',
  },
  {
    label: 'obor činnosti',
    id: 'RT_ACTIVITYFIELD',
  },
  {
    label: 'obor studia',
    id: 'RT_STUDYFIELD',
  },
  {
    label: 'ocenění',
    id: 'RT_AWARD',
  },
  {
    label: 'organizátor, svolavatel',
    id: 'RT_ORGANIZER',
  },
  {
    label: 'otec',
    id: 'RT_FATHER',
  },
  {
    label: 'partner',
    id: 'RT_PARTNER',
  },
  {
    label: 'partner',
    id: 'RT_GEOPARTNER',
  },
  {
    label: 'partnerka',
    id: 'RT_SHEPARTNER',
  },
  {
    label: 'pojmenováno po',
    id: 'RT_NAMEDAFTER',
  },
  {
    label: 'poslední známý člen rodu/rodiny',
    id: 'RT_LASTKMEMBER',
  },
  {
    label: 'první známý člen rodu/rodiny',
    id: 'RT_FIRSTKMEMBER',
  },
  {
    label: 'předchůdce',
    id: 'RT_PREDECESSOR',
  },
  {
    label: 'příslušnost k',
    id: 'RT_AFFILIATION',
  },
  {
    label: 'sestra',
    id: 'RT_SISTER',
  },
  {
    label: 'sestřenice',
    id: 'RT_SHECOUSIN',
  },
  {
    label: 'sídlo',
    id: 'RT_RESIDENCE',
  },
  {
    label: 'souborná událost, celek',
    id: 'RT_COMPEVENT',
  },
  {
    label: 'související entita',
    id: 'RT_RELATED',
  },
  {
    label: 'související pojem',
    id: 'RT_RELATEDTERM',
  },
  {
    label: 'spolupracovník',
    id: 'RT_COLLABORATOR',
  },
  {
    label: 'spolužák',
    id: 'RT_SCHOOLMATE',
  },
  {
    label: 'strýc',
    id: 'RT_UNCLE',
  },
  {
    label: 'škola',
    id: 'RT_SCHOOL',
  },
  {
    label: 'švagr',
    id: 'RT_BROTHERINLAW',
  },
  {
    label: 'švagrová',
    id: 'RT_SISTERINLAW',
  },
  {
    label: 'taxonomická kategorie',
    id: 'RT_CATEGORY',
  },
  {
    label: 'tematický celek',
    id: 'RT_THEME',
  },
  {
    label: 'teta',
    id: 'RT_AUNT',
  },
  {
    label: 'tchán',
    id: 'RT_FATHERINLAW',
  },
  {
    label: 'tchyně',
    id: 'RT_MOTHERINLAW',
  },
  {
    label: 'učitel',
    id: 'RT_TEACHER',
  },
  {
    label: 'udělovatel',
    id: 'RT_GRANTAUTH',
  },
  {
    label: 'uložení',
    id: 'RT_STORAGE',
  },
  {
    label: 'umístění',
    id: 'RT_LOCATION',
  },
  {
    label: 'vazba na objekt',
    id: 'RT_OBJECT',
  },
  {
    label: 'významné aktivity',
    id: 'RT_ACTIVITIES',
  },
  {
    label: 'zakladatel/zřizovatel',
    id: 'RT_FOUNDER',
  },
  {
    label: 'zřizovatel',
    id: 'RT_ORIGINATOR',
  },
  {
    label: 'zaměstnavatel',
    id: 'RT_EMPLOYER',
  },
  {
    label: 'zjednodušená podniková entita',
    id: 'RT_ROOF',
  },
  {
    label: 'zástupce',
    id: 'RT_REPRESENT',
  },
  {
    label: 'změna jména/identity',
    id: 'RT_NAMECHANGE',
  },
  {
    label: 'zmínka o existenci',
    id: 'RT_MENTION',
  },
];
